/**
 * Used to trigger an async action when a button is clicked. Sets the button in a temporary state, while the action is executing
 */
export async function performButtonAction<T>(button: HTMLButtonElement, action: () => Promise<T>): Promise<T> {
    const buttonContent = button.innerHTML

    // Set temporary button style during action
    button.disabled = true
    button.innerHTML = `<span class="k-icon k-i-loading"><span style="visibility:hidden">${buttonContent}</span></span>`

    return await action()
        .finally(() => {
            // Reset button style
            button.disabled = false
            button.innerHTML = buttonContent
        })
}